// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SetCapacity extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  get timeUnitsTotal(): number {
    return this.timeUnitsChargeable + this.timeUnitsNonChargeable;
  }
  set timeUnitsTotal(value: number) {
    const diff = value - this.timeUnitsChargeable;
    if (diff >= 0) {
      this.timeUnitsNonChargeable = diff;
    } else {
      this.timeUnitsChargeable = value;
    }
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createdAt!: Date;
  createdBy?: string;
  dateFrom?: Date;
  dateTo?: Date;
  hierarchy!: number;
  practiceId?: number;
  timeUnitsChargeable!: number;
  timeUnitsNonChargeable!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  userId?: number;
  userTypeId?: number;
}

